module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-learning"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeRevenue'),
      expression: "selectedItem === 'projectTypeRevenue'"
    }],
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedProjectType, 'col-lg-3': _vm.selectedProjectType
    }
  }, [_c('projectTypeRevenue-table', {
    attrs: {
      "title": "Hvilke opgavetyper tjenes der penge på?"
    },
    on: {
      "selectProjectType": function($event) {
        return _vm.setSelectedProjectType($event)
      },
      "finishedLoading": function($event) {
        return _vm.updateCount('projectTypeRevenue', $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.selectedProjectType) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])]), _vm._v(" "), _c('showTypeRevenue-table', {
    attrs: {
      "rows": _vm.$store.getters.groupedProjects[_vm.selectedProjectType],
      "title": "Konkrete opgaver"
    }
  })], 1) : _c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                Vælg en opgavetype for at se en liste over alle opgaver og deres konkrete indtjening.\n            ")])]), _vm._v(" "), _c('closedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }],
    attrs: {
      "title": "Hvilke konkrete opgaver tjenes der penge på?"
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('closedProjectsRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('project-type-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeSkills'),
      expression: "selectedItem === 'projectTypeSkills'"
    }]
  }), _vm._v(" "), _c('project-type-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeDevelopment'),
      expression: "selectedItem === 'projectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('project-type-coverage-per-hour-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'coveragePerHourPerProjectTypeDevelopment'),
      expression: "selectedItem === 'coveragePerHourPerProjectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }]
  })])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41150ece", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41150ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/learning.vue
// module id = 823
// module chunks = 0